import { Language } from '../../types/language'

export type PrivacySection = {
  title: string
  body: string[]
}

export type PrivacyCopy = {
  heading: string
  updated: string
  back: string
  sections: PrivacySection[]
}

export const privacyCopy: Record<Language, PrivacyCopy> = {
  nl: {
    heading: 'Privacybeleid',
    updated: 'Laatst bijgewerkt: september 2026',
    back: 'Terug naar de homepage',
    sections: [
      {
        title: 'Wie is verantwoordelijk',
        body: [
          'MarkV Coaching, KvK 42124404, is verantwoordelijk voor de verwerking van je persoonsgegevens. Je kunt ons bereiken via info@markvcoaching.com.',
        ],
      },
      {
        title: 'Welke gegevens ik verwerk',
        body: [
          'Ik verwerk alleen de gegevens die je zelf met me deelt: je naam, e-mailadres, telefoonnummer en de inhoud van je bericht of aanmelding voor de wachtlijst.',
          'Wat je tijdens een coachingsessie deelt, blijft vertrouwelijk en wordt niet met derden gedeeld.',
        ],
      },
      {
        title: 'Waarvoor ik je gegevens gebruik',
        body: [
          'Om contact met je op te nemen, een kennismaking of sessie in te plannen, en om je te informeren over data van retreats wanneer je je hiervoor hebt aangemeld.',
        ],
      },
      {
        title: 'Hoe lang ik gegevens bewaar',
        body: [
          'Ik bewaar je gegevens niet langer dan nodig is voor het doel waarvoor je ze hebt achtergelaten. Aanmeldingen voor de wachtlijst verwijder ik zodra de retreat heeft plaatsgevonden of je je afmeldt.',
        ],
      },
      {
        title: 'Jouw rechten',
        body: [
          'Je kunt altijd vragen welke gegevens ik van je heb, ze laten corrigeren of laten verwijderen. Stuur een bericht naar info@markvcoaching.com en ik reageer binnen twee weken.',
        ],
      },
    ],
  },
  en: {
    heading: 'Privacy Policy',
    updated: 'Last updated: September 2026',
    back: 'Back to the homepage',
    sections: [
      {
        title: 'Who is responsible',
        body: [
          'MarkV Coaching, Dutch Chamber of Commerce 42124404, is responsible for processing your personal data. You can reach us at info@markvcoaching.com.',
        ],
      },
      {
        title: 'What data I process',
        body: [
          'I only process the data you share with me: your name, email address, phone number, and the contents of your message or waitlist sign-up.',
          'Anything you share during a coaching session stays confidential and is never shared with third parties.',
        ],
      },
      {
        title: 'What I use your data for',
        body: [
          'To get in touch with you, to schedule an intro call or session, and to let you know about retreat dates if you signed up for the waitlist.',
        ],
      },
      {
        title: 'How long I keep data',
        body: [
          'I keep your data no longer than needed for the purpose you shared it for. Waitlist sign-ups are removed once the retreat has taken place or you unsubscribe.',
        ],
      },
      {
        title: 'Your rights',
        body: [
          'You can always ask which data I hold, have it corrected, or have it deleted. Send a message to info@markvcoaching.com and I will respond within two weeks.',
        ],
      },
    ],
  },
}
